type PickedFile = { uri?: string; name?: string; type?: string; mimeType?: string; size?: number; file?: File };

/** Accept both browser drop Files and Expo picker assets without persisting either. */
export const prepareSurveyUpload = (candidate: unknown, web: boolean) => {
  if (!candidate || typeof candidate !== 'object') throw new Error('No file selected.');
  const asset = candidate as PickedFile;
  const browserFile = web && typeof File !== 'undefined'
    ? candidate instanceof File ? candidate : asset.file instanceof File ? asset.file : undefined
    : undefined;
  if (web ? !browserFile : !asset.uri) throw new Error('The selected file is unavailable.');
  const name = browserFile?.name ?? asset.name ?? 'survey-upload';
  const type = browserFile?.type || asset.mimeType || asset.type || (/\.pdf$/i.test(name) ? 'application/pdf' : 'application/octet-stream');
  const size = browserFile?.size ?? asset.size;
  if (size !== undefined && (size <= 0 || size > 10 * 1024 * 1024)) throw new Error('File must be between 1 byte and 10 MB.');
  if (!type.startsWith('image/') && type !== 'application/pdf') throw new Error('Only images and PDFs are supported.');
  return { name, type, body: browserFile ?? { uri: asset.uri, name, type } };
};
